module.exports = "https://cwa.roocdn.com/_next/static/rider-scooter.5603c6c6.png";